import {usePersonalData} from 'presentation/hooks';
import {handleServiceTypeConfigs} from 'presentation/pages/private/booking/utils/handleServiceType/handleServiceTypeConfigs';
import {useCallback, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useBookingFlowStepsStore} from '../../store/useBookingFlowStepsStore';
import {useBookingStore} from '../../store/useBookingStore';
import {useResetBookingFlow} from '../useResetBookingFlow';
import {UseBackButtonBookingProps} from './types';

export function useBackButtonBooking({flowType}: UseBackButtonBookingProps) {
	const navigate = useNavigate();
	const setBookingData = useBookingStore(state => state.setBookingData);
	const {currentPhone, currentEmail} = usePersonalData();
	const setActiveBookingFlowStep = useBookingFlowStepsStore(state => state.setBookingStep);
	const {resetBookingFlow} = useResetBookingFlow();

	const urlChangeHandler = useCallback((replace = false) => {
		const historyMethod = replace ? 'replaceState' : 'pushState';
		for (let i = 0; i < 10; i += 1) {
			window.history[historyMethod](null, '');
		}
	}, []);

	useEffect(() => {
		urlChangeHandler();
	}, [urlChangeHandler]);

	useEffect(() => {
		const handlePopState = (event: PopStateEvent) => {
			event.preventDefault();

			const route = handleServiceTypeConfigs({
				currentSearchParams: new URLSearchParams(window.location.search),
				setBookingData,
				selectedServiceType: flowType,
				phone: currentPhone,
				email: currentEmail,
			});

			setActiveBookingFlowStep(0);
			resetBookingFlow();
			navigate(route);
		};

		window.addEventListener('popstate', handlePopState);
		urlChangeHandler();

		return () => {
			window.removeEventListener('popstate', handlePopState);
		};
	}, [urlChangeHandler, flowType]);
}
